var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColumns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "7px",
    viewBox: "-0.45 -0.45 7 7",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.55942528,0.38340864 L0.57511296,0.38340864 C0.257482865,0.38340864 0,0.640891505 0,0.9585216 L0,5.17601664 C0,5.49364674 0.257482865,5.7511296 0.57511296,5.7511296 L5.55942528,5.7511296 C5.87705538,5.7511296 6.13453824,5.49364674 6.13453824,5.17601664 L6.13453824,0.9585216 C6.13453824,0.640891505 5.87705538,0.38340864 5.55942528,0.38340864 Z M2.68386048,4.98431232 L0.76681728,4.98431232 L0.76681728,1.9170432 L2.68386048,1.9170432 L2.68386048,4.98431232 Z M5.36772096,4.98431232 L3.45067776,4.98431232 L3.45067776,1.9170432 L5.36772096,1.9170432 L5.36772096,4.98431232 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumns);
export default __webpack_public_path__ + "static/media/columns.bd1c6871296f72698588e3bb30e33047.svg";
export { ForwardRef as ReactComponent };